<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" v-show="state">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <transition
        enter-active-class="transition ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div class="fixed inset-0 transition-opacity" v-show="state">
          <div class="absolute inset-0 bg-gray-900 opacity-75"></div>
        </div>
      </transition>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
      >&#8203;
      <transition
        enter-active-class="transition ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="transition ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          v-show="state"
        >
          <div
            class="bg-gray-50 px-4 pt-6 sm:px-6 sm:flex sm:flex-row-reverse"
          >
            <span
              @click="state = false"
              class="cursor-pointer mt-3 bg-gray-200 px-4 h-12 flex self-center w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
            >
              <Icon name="Close" class="w-8" />
            </span>
          </div>
          <Plans />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import Plans from "@/components/Plans";
import Icon from "@/components/UI/Icon";

export default {
  components: { Plans, Icon },
  props: {
    isVisible: Boolean,
  },
  setup(props, { emit }) {
    const store = useStore();

    const state = computed({
      get: () => props.isVisible,
      set: (newValue) => {
        emit("update:isVisible", newValue);
        store.commit("SET_OURPLANS_ACTIVE", newValue);
      },
    });

    return { state };
  },
};
</script>

<style></style>
